import styled from 'styled-components';
import { Typography } from '@mui/material';
import { ReactComponent as TreeGraphic } from '../../assets/tree-graphic.svg';
import { FlexCenter, FlexColumn } from '../Flex';

const Wrapper = styled(FlexColumn)`
  width: fit-content;
  align-items: center;
  background: ${({ theme }) => theme.palette.common.white};
  border: 1px solid ${({ theme }) => theme.palette.common.gray13};
  padding: 80px;
  gap: 40px;
  border-radius: 8px;
  box-shadow: 0px 16px 250px 0px rgba(0, 0, 0, 0.05);
`;

type Props = {
  allowFolders?: boolean;
};

const SelectDatasetPage = ({ allowFolders }: Props) => (
  <FlexCenter
    sx={{
      width: '100%',
      height: '100%',
    }}
  >
    <Wrapper>
      <FlexColumn sx={{ gap: 1, alignItems: 'center', background: 'none' }}>
        <Typography sx={{ fontWeight: 'bold' }}>{`Select a dataset ${
          allowFolders ? 'or folder' : ''
        }`}</Typography>
        <Typography sx={{ color: 'common.gray2' }}>
          You will find all your datasets on the left panel
        </Typography>
      </FlexColumn>
      <TreeGraphic />
    </Wrapper>
  </FlexCenter>
);

export default SelectDatasetPage;
